import { getBondingLevelDisplay } from '../../../utils/horseHelpers';

/**
 * Bonding Level Display Component
 * Shows the bonding level with visual indicators
 */
const BondingLevelDisplay = ({ level = 0, showDetails = true }) => {
  const display = getBondingLevelDisplay(level);
  
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium">Bonding Level</span>
        <span className="text-lg font-bold" style={{ color: display.color }}>
          {display.emoji} {level}/100
        </span>
      </div>
      
      {/* Progress bar */}
      <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${level}%`,
            backgroundColor: display.color
          }}
        />
      </div>
      
      {showDetails && (
        <div className="text-xs space-y-1">
          <div className="font-semibold" style={{ color: display.color }}>
            {display.label}
          </div>
          <div className="text-gray-600">
            {display.description}
          </div>
        </div>
      )}
    </div>
  );
};

export default BondingLevelDisplay;
